<template>
    <div>
        <login-header />
        <div class="login">
            <div class="logo-icon">
                <div class="mr-re"></div>
                <div class="mr-bil"></div>
                <div class="mr-ly"></div>
            </div>
            <div class="tile stack-m">
                <div class="tile-title">
                    <h2>Forgot Password</h2>
                </div>
                <div class="tile-content">
                    <template v-if="!emailSent">
                        <p class="stack-m">
                            A reset password link will be sent.
                        </p>
                        <r-input
                                label="Email"
                                v-model="form.email"
                                :validate="$v.form.email"
                                class="stack-l"
                                left-icon="customers"
                                @key-submit="submit"
                        />
                        <r-button type="primary" :loading="isLoading" :fluid="true" class="stack-m" @click="submit">Send</r-button>
                    </template>
                    <template v-else>
                        <p class="inset-m message stack-m">
                            Password reset instructions have been sent to <strong>{{ form.email }}</strong>.
                        </p>
                    </template>
                        <p class="text-center">
                            <router-link :disabled="isLoading" :to="{name: 'login'}">Return to Login</router-link>
                        </p>
                </div>
            </div>
            <v-error-messages
                :has-frontend-errors="$v.form.$error"
                :server-error="serverError"
                class="stack-m">
                <li class="list-item" v-if="!serverError && !$v.form.email.required">Email is required</li>
                <li class="list-item" v-if="!serverError && !$v.form.email.email">Email is invalid</li>
            </v-error-messages>
        </div>
    </div>
</template>

<script>
    import LoginHeader from '@/modules/guest/login-header';
    import {vErrorMessages} from '@/components/form';
    import {required, email} from 'vuelidate/lib/validators';

    export default {
        components: {
            LoginHeader, vErrorMessages,
        },
        data() {
            return {
                form: {
                    email: null,
                },
                isLoading: false,
                serverError: null,
                emailSent: false,
            };
        },
        validations: {
            form: {
                email: {required, email},
            },
        },
        methods: {
            cancel() {
                this.$v.$reset();
                this.emailSent = false;
            },
            async submit() {
                this.$v.$touch();
                if (!this.$v.form.$error) {
                    this.isLoading = true;
                    try {
                        const data = {email: this.form.email};
                        const response = await this.$api(({account}) => account.forgotPassword({data}));
                        if (response.response.status === 204) {
                            this.emailSent = true;
                        }
                    } catch (error) {
                        const {status} = error;
                        if (status === 422) {
                            this.serverError = error;
                        }
                    } finally {
                        this.isLoading = false;
                    }
                }
            },
        },
    };
</script>
